import {Link} from 'quickstart/components/content/Link'
import styled from 'quickstart/system'
import {ComponentProps} from 'react'

// styled for the sake of polymorphism
export const NavLinkLink = styled(Link).attrs<{
  text?: string
  label?: string
  link?: string
}>(
  ({
    text,
    label = text,
    children = label,
    link,
    href = link,
    variant = 'nav',
  }) => ({
    children,
    href,
    variant,
    label: undefined,
    text: undefined,
    link: undefined,
  }),
)``

export type NavLinkLinkProps = ComponentProps<typeof NavLinkLink>
